var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    fill: "#F0F6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    stroke: "#F0F6FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3089 11.3333L2.69241 7.33334L10.3089 3.33334L17.9254 7.33334L10.3089 11.3333ZM10.3089 14L3.09055 10.2167L4.54461 9.45001L10.3089 12.4833L16.0732 9.45001L17.5273 10.2167L10.3089 14ZM10.3089 16.6667L3.09055 12.8833L4.54461 12.1167L10.3089 15.15L16.0732 12.1167L17.5273 12.8833L10.3089 16.6667ZM10.3089 9.81668L15.0346 7.33334L10.3089 4.85001L5.58323 7.33334L10.3089 9.81668Z",
    fill: "#005BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsPortfolio);
export default __webpack_public_path__ + "static/media/AppsPortfolio.756382bcc2924976164f189304fb5905.svg";
export { ForwardRef as ReactComponent };